import { ArrowSort } from '@pages/Products/components/ListProducts/helpers/ArrowSort';
import {
  FieldHeaderWrap,
  FieldTextArrowGroup,
  FieldHeaderText,
} from '@pages/Products/components/ListProducts/ListProducts.styles';
import { useSelector } from 'react-redux';
import { checkDevice } from '@store/redux/features/mobile/mobileSelectors';

interface UpdatesHeader {
  sortString: string;
  label: string;

  disabled?: boolean;
  tooltipId?: string;
  tooltipText?: string;
  rightIcon?: React.ReactNode;
  onSort: VoidFunction;
  currentSort: string | undefined;
  direction: 'ASC' | 'DESC' | undefined;
}
export function FieldHeaderUpdatesAsset(props: UpdatesHeader) {
  const { isMobile } = useSelector(checkDevice());
  const {
    sortString,
    label,
    disabled = false,
    tooltipId,
    tooltipText,
    onSort,
    rightIcon,
    currentSort,
    direction,
  } = props;

  return (
    <FieldHeaderWrap
      data-disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
      onClick={() => {
        if (!disabled) {
          onSort();
        }
      }}
    >
      <FieldTextArrowGroup>
        <FieldHeaderText
          text="p100"
          textColor={isMobile ? 'n700' : 'n600'}
          data-for={tooltipId}
          data-tip={tooltipText}
        >
          {label}
        </FieldHeaderText>
        <ArrowSort
          isSorted={currentSort === sortString}
          direction={direction}
        />
      </FieldTextArrowGroup>
      {rightIcon}
    </FieldHeaderWrap>
  );
}
